import { useTranslation } from "react-i18next";
import { FileText } from "@phosphor-icons/react";
import PortalPageHeader from "../../components/portal/PortalPageHeader";
import PortalEmptyState from "../../components/portal/PortalEmptyState";

export default function PortalInvoices() {
  const { t } = useTranslation();
  return (
    <div data-testid="portal-invoices-page" className="space-y-8">
      <PortalPageHeader
        kickerKey="portal.placeholder.kicker"
        titleKey="portal.invoices.title"
        subtitleKey="portal.invoices.subtitle"
        right={
          <div
            data-testid="invoices-compliance"
            className="flex items-center gap-4"
          >
            <img
              src="/facturation-electronique.png"
              alt="Facturation électronique"
              className="h-32 w-32 md:h-36 md:w-36 shrink-0 object-contain"
              loading="lazy"
            />
            <p className="text-xs text-slate-500 leading-snug max-w-[170px]">
              {t("portal.invoices.compliance")}
            </p>
          </div>
        }
      />

      <PortalEmptyState
        variant="solid"
        icon={FileText}
        titleKey="portal.invoices.empty_title"
        descKey="portal.invoices.empty_desc"
      />
    </div>
  );
}
